import { addListener } from 'rtk';

import {
  /* in */
  subscribe,
  subscriptionLost,
  incomingMessage,
  unsubscribe,
} from './actions';
import {
  addEventListener,
  removeEventListeners,
} from '@rails/document/actions';
import { unsubscribe as unsub } from '@rails/cable';

import {
  selectEmptySubscriptions,
  selectActions,
  selectIdentifier,
} from './selectors';

addListener(
  addEventListener,
  ({ payload: { uuid, subscription } }, { getState, dispatch }) => {
    const identifier = selectIdentifier(getState(), subscription);

    identifier || dispatch(subscribe(subscription));
  },
  null,
);

addListener(
  removeEventListeners,
  ({ payload: { uuid } }, { getState, dispatch }) => {
    const identifiers = selectEmptySubscriptions(getState());
    identifiers.forEach((identifier) => dispatch(unsubscribe(identifier)));
  },
  null,
);

addListener(
  incomingMessage,
  ({ payload: { subscription } }, { getState, dispatch }) => {
    const actions = selectActions(getState(), subscription);

    actions.forEach(dispatch);
  },
  null,
);

addListener(
  unsubscribe,
  ({ payload: { identifier } }, { dispatch, getState }) => {
    unsub(identifier);
  },
  null,
);

addListener(
  subscribe.rejected,
  (
    {
      meta: {
        arg: { type, id },
      },
    },
    { dispatch, getState },
  ) => {
    dispatch(subscriptionLost({ type, id }));
  },
  null,
);
